// src/modules/appointments/components/AvailabilityViewer.jsx

export default function AvailabilityViewer({
  slots = [],
  onPick,
  loading,
}) {
  if (loading) {
    return <div className="text-xs text-gray-500">Cargando disponibilidad...</div>;
  }

  if (!slots.length) {
    return <div className="text-xs text-gray-500">Sin slots para este día.</div>;
  }

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-xs mt-2">
      {slots.map((s, i) => (
        <button
          type="button"
          key={i}
          disabled={!s.available}
          onClick={() => s.available && onPick && onPick(s)}
          className={`border rounded px-2 py-1 text-left ${
            s.available
              ? "hover:bg-emerald-900/30"
              : "bg-gray-100 text-gray-400 cursor-not-allowed"
          }`}
        >
          <div>{s.start.slice(11, 16)} - {s.end.slice(11, 16)}</div>
          <div className="text-[10px]">
            {s.available ? "Disponible" : "Ocupado"}
          </div>
        </button>
      ))}
    </div>
  );
}
